import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createBillingReconciliationCredit,
  createBillingReconciliationNote,
  createBillingReconciliationVarianceAction,
  deleteBillingReconciliationVarianceAction,
  deleteBillingReconciliationNote,
  downloadBillingReconciliationActionSummaryCsv,
  downloadBillingReconciliationExport,
  downloadBillingReconciliationExportArtifact,
  downloadBillingReconciliationExportBundle,
  downloadBillingReconciliationExportLineageCsv,
  getBillingReconciliationActionSummary,
  getBillingReconciliationExportPreview,
  getBillingReconciliationVarianceCompletionReadiness,
  listBillingReconciliationExports,
  listBillingReconciliationCredits,
  listBillingReconciliationLifecycleAlerts,
  listBillingReconciliationNoteTemplates,
  listBillingReconciliationRuns,
  listBillingReconciliationVarianceActions,
  listBillingReconciliationVariances,
  resolveBillingReconciliationVarianceActions,
  resetBillingReconciliationVarianceReviews,
  resetBillingReconciliationVarianceActions,
  saveBillingReconciliationVarianceActions,
  updateBillingReconciliationLifecycleAlert,
  updateBillingReconciliationNote,
  updateBillingReconciliationVarianceAction,
  updateBillingReconciliationVarianceReview,
} from './billingReconciliationApi.js';
import {
  useBillingReconciliationRecurringRules,
  useBillingReconciliationSuggestedMatches,
  useConfirmBillingReconciliationSuggestedMatch,
  usePromoteBillingReconciliationActionToRecurringRule,
  useRejectBillingReconciliationSuggestedMatch,
  useUpdateBillingReconciliationRecurringRule,
} from './useBillingReconciliationRecurringHooks.js';
import {
  useBillingReconciliationAppSheetAccounts,
  useBillingReconciliationBacAccounts,
  useBillingReconciliationContextWarmStatus,
  useBillingReconciliationFullEvidence,
  useBillingReconciliationGmRows,
  useQueueBillingReconciliationContextWarm,
  useRefreshBillingReconciliationBacContext,
  useBillingReconciliationRowEvidence,
} from './useBillingReconciliationEvidenceHooks.js';
import {
  useBulkReviewBillingReconciliationFileHealth,
  useBillingReconciliationFileHealth,
  useBillingReconciliationFileHealthSummary,
  useRefreshBillingReconciliationFileHealth,
  useReviewBillingReconciliationFileHealth,
} from './useBillingReconciliationFileHealthHooks.js';
import {
  useCreateBillingReconciliationRun,
  useDeleteBillingReconciliationRun,
  useImportBillingReconciliationHistoricalBackfill,
  usePreviewBillingReconciliationHistoricalBackfill,
} from './useBillingReconciliationRunMutationHooks.js';
import {
  useBillingReconciliationHistory,
  useBillingReconciliationHistoryBacLookup,
  useUpdateBillingReconciliationHistoryAdjustment,
} from './useBillingReconciliationHistoryHooks.js';
import {
  useBillingReconciliationDpeActions,
  useCreateBillingReconciliationDpeAction,
  useDeleteBillingReconciliationDpeAction,
  useSendBillingReconciliationDpeActions,
  useUpdateBillingReconciliationDpeAction,
} from './useBillingReconciliationDpeActionHooks.js';
import {
  useBillingReconciliationCatalog,
  useMarkBillingReconciliationCatalogItemReviewed,
  useUpdateBillingReconciliationCatalogItem,
} from './useBillingReconciliationCatalogHooks.js';
import {
  invalidateBillingBacContext,
  invalidateBillingVarianceLists,
  scheduleBillingQueryInvalidation,
} from './billingReconciliationQueryInvalidation.js';
import { billingReconKeys } from './billingReconciliationQueryKeys.js';
import { patchVarianceReviewCaches } from './billingReconciliationReviewCache.js';
import {
  reconcileLifecycleAlertCaches,
  scheduleLifecycleDependents,
} from './billingReconciliationLifecycleCache.js';
import { useRefreshBillingReconciliationVarianceClassifications } from './useBillingReconciliationVarianceRefreshHook.js';
export { downloadBillingReconciliationSourceFile as downloadBillingReconciliationSourceFileFromHistory } from './billingReconciliationHistoryApi.js';
export { useRefreshBillingReconciliationVarianceClassifications } from './useBillingReconciliationVarianceRefreshHook.js';
export {
  useBillingReconciliationRecurringRules,
  useBillingReconciliationSuggestedMatches,
  useConfirmBillingReconciliationSuggestedMatch,
  usePromoteBillingReconciliationActionToRecurringRule,
  useRejectBillingReconciliationSuggestedMatch,
  useUpdateBillingReconciliationRecurringRule,
} from './useBillingReconciliationRecurringHooks.js';
export {
  useBillingReconciliationAppSheetAccounts,
  useBillingReconciliationBacAccounts,
  useBillingReconciliationContextWarmStatus,
  useBillingReconciliationFullEvidence,
  useBillingReconciliationGmRows,
  useQueueBillingReconciliationContextWarm,
  useRefreshBillingReconciliationBacContext,
  useBillingReconciliationRowEvidence,
} from './useBillingReconciliationEvidenceHooks.js';
export {
  useBulkReviewBillingReconciliationFileHealth,
  useBillingReconciliationFileHealth,
  useBillingReconciliationFileHealthSummary,
  useRefreshBillingReconciliationFileHealth,
  useReviewBillingReconciliationFileHealth,
} from './useBillingReconciliationFileHealthHooks.js';
export {
  useCreateBillingReconciliationRun,
  useDeleteBillingReconciliationRun,
  useImportBillingReconciliationHistoricalBackfill,
  usePreviewBillingReconciliationHistoricalBackfill,
} from './useBillingReconciliationRunMutationHooks.js';
export {
  useBillingReconciliationHistory,
  useBillingReconciliationHistoryBacLookup,
  useUpdateBillingReconciliationHistoryAdjustment,
} from './useBillingReconciliationHistoryHooks.js';
export {
  useBillingReconciliationDpeActions,
  useCreateBillingReconciliationDpeAction,
  useDeleteBillingReconciliationDpeAction,
  useSendBillingReconciliationDpeActions,
  useUpdateBillingReconciliationDpeAction,
} from './useBillingReconciliationDpeActionHooks.js';
export {
  useBillingReconciliationCatalog,
  useMarkBillingReconciliationCatalogItemReviewed,
  useUpdateBillingReconciliationCatalogItem,
} from './useBillingReconciliationCatalogHooks.js';
export { billingReconKeys } from './billingReconciliationQueryKeys.js';
const listRows = (payload) => {
  if (Array.isArray(payload)) return payload;
  const rows = payload?.rows || [];
  if (Array.isArray(rows) && payload && typeof payload === 'object') {
    Object.defineProperty(rows, 'meta', {
      value: {
        total: payload.total,
        returned: payload.returned,
        limit: payload.limit,
        offset: payload.offset,
        hasMore: payload.hasMore,
      },
      enumerable: false,
      configurable: true,
    });
  }
  return rows;
};
const noRetry = { retry: false };
const varianceListRetry = {
  retry: (failureCount, error) => {
    const status = Number(error?.response?.status || 0);
    if (status === 429) return false;
    return (status === 0 || status === 408 || status >= 500) && failureCount < 1;
  },
  retryDelay: 750,
};
const invalidateActionDependents = (queryClient, variables = {}) => {
  if (variables?.varianceId) {
    queryClient.invalidateQueries({ queryKey: billingReconKeys.actions({ varianceId: variables.varianceId }) });
  } else {
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'varianceActions'] });
  }
  if (variables?.runId) {
    queryClient.invalidateQueries({ queryKey: billingReconKeys.actionSummary({ runId: variables.runId }) });
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'varianceCompletionReadiness', variables.runId] });
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'exportPreview', variables.runId] });
    scheduleBillingQueryInvalidation(queryClient, {
      queryKey: ['billingRecon', 'variancesAll', variables.runId],
      delayMs: 3_000,
      refetchType: 'active',
    });
    scheduleBillingQueryInvalidation(queryClient, {
      queryKey: ['billingRecon', 'variances', variables.runId],
      delayMs: 3_000,
      refetchType: 'active',
    });
  } else {
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'variances'] });
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'actionSummary'] });
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'exportPreview'] });
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'varianceCompletionReadiness'] });
  }
};

export const useBillingReconciliationRuns = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.runs(params),
    queryFn: ({ signal }) => listBillingReconciliationRuns({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.program),
    staleTime: 30 * 1000,
    ...noRetry,
    ...options,
  });

export const useBillingReconciliationVariances = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.variances(params),
    queryFn: ({ signal }) => listBillingReconciliationVariances({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.runId),
    select: listRows,
    staleTime: 60 * 1000,
    ...varianceListRetry,
    ...options,
  });

export const useBillingReconciliationLifecycleAlerts = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.alerts(params),
    queryFn: ({ signal }) => listBillingReconciliationLifecycleAlerts({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.runId),
    select: listRows,
    staleTime: 30 * 1000,
    ...noRetry,
    ...options,
  });

export const useBillingReconciliationCredits = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.credits(params),
    queryFn: ({ signal }) => listBillingReconciliationCredits({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.runId),
    select: listRows,
    staleTime: 30 * 1000,
    ...noRetry,
    ...options,
  });

export const useCreateBillingReconciliationCredit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBillingReconciliationCredit,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'credits', variables?.runId] });
      invalidateBillingBacContext(queryClient, { runId: variables?.runId });
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'exportPreview', variables?.runId] });
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'exports', variables?.runId] });
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'actionSummary', variables?.runId] });
    },
  });
};

export const useBillingReconciliationNoteTemplates = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.noteTemplates(params),
    queryFn: ({ signal }) => listBillingReconciliationNoteTemplates({ ...params, signal }),
    enabled: options.enabled ?? true,
    select: listRows,
    staleTime: 60 * 1000,
    ...noRetry,
    ...options,
  });

export const useBillingReconciliationVarianceActions = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.actions(params),
    queryFn: ({ signal }) => listBillingReconciliationVarianceActions({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.varianceId),
    select: listRows,
    staleTime: 15 * 1000,
    ...noRetry,
    ...options,
  });

export const useBillingReconciliationVarianceCompletionReadiness = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.varianceCompletionReadiness(params),
    queryFn: ({ signal }) => getBillingReconciliationVarianceCompletionReadiness({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.varianceId),
    staleTime: 10 * 1000,
    ...noRetry,
    ...options,
  });

export const useBillingReconciliationExportPreview = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.exportPreview(params),
    queryFn: ({ signal }) => getBillingReconciliationExportPreview({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.runId),
    staleTime: 15 * 1000,
    ...noRetry,
    ...options,
  });

export const useBillingReconciliationActionSummary = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.actionSummary(params),
    queryFn: ({ signal }) => getBillingReconciliationActionSummary({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.runId),
    staleTime: 15 * 1000,
    ...noRetry,
    ...options,
  });

export const useBillingReconciliationExports = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconKeys.exports(params),
    queryFn: ({ signal }) => listBillingReconciliationExports({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.runId),
    staleTime: 15 * 1000,
    ...noRetry,
    ...options,
  });

export const downloadBillingReconciliationExportFile = downloadBillingReconciliationExport;
export const downloadBillingReconciliationActionSummaryCsvFile = downloadBillingReconciliationActionSummaryCsv;
export const downloadBillingReconciliationExportLineageCsvFile = downloadBillingReconciliationExportLineageCsv;
export const downloadBillingReconciliationExportArtifactFile = downloadBillingReconciliationExportArtifact;
export const downloadBillingReconciliationExportBundleFile = downloadBillingReconciliationExportBundle;
export const useUpdateBillingReconciliationVarianceReview = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateBillingReconciliationVarianceReview,
    onSuccess: (data, variables) => {
      patchVarianceReviewCaches(queryClient, data, variables);
      invalidateBillingVarianceLists(queryClient, { runId: variables?.runId });
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'runs'] });
      if (variables?.patch?.resolveActionsOnComplete) {
        invalidateActionDependents(queryClient, variables);
      }
    },
  });
};

export const useResetBillingReconciliationVarianceReviews = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resetBillingReconciliationVarianceReviews,
    onSuccess: (_data, variables) => {
      invalidateBillingVarianceLists(queryClient, { runId: variables?.runId });
      invalidateBillingBacContext(queryClient, { runId: variables?.runId });
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'runs'] });
      queryClient.invalidateQueries({ queryKey: billingReconKeys.actionSummary({ runId: variables?.runId }) });
    },
  });
};

export const useCreateBillingReconciliationNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBillingReconciliationNote,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'variances'] });
      invalidateBillingBacContext(queryClient, { runId: variables?.runId });
      if (variables?.varianceId) queryClient.invalidateQueries({ queryKey: ['billingRecon', 'notes', variables.varianceId] });
    },
  });
};

export const useUpdateBillingReconciliationNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateBillingReconciliationNote,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'variances'] });
      invalidateBillingBacContext(queryClient, { runId: variables?.runId });
    },
  });
};

export const useDeleteBillingReconciliationNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteBillingReconciliationNote,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'variances'] });
      invalidateBillingBacContext(queryClient, { runId: variables?.runId });
    },
  });
};

export const useCreateBillingReconciliationVarianceAction = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBillingReconciliationVarianceAction,
    onSuccess: (_data, variables) => {
      invalidateActionDependents(queryClient, variables);
    },
  });
};

export const useUpdateBillingReconciliationVarianceAction = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateBillingReconciliationVarianceAction,
    onSuccess: (_data, variables) => {
      invalidateActionDependents(queryClient, variables);
    },
  });
};

export const useDeleteBillingReconciliationVarianceAction = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteBillingReconciliationVarianceAction,
    onSuccess: (_data, variables) => {
      invalidateActionDependents(queryClient, variables);
    },
  });
};

export const useSaveBillingReconciliationVarianceActions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveBillingReconciliationVarianceActions,
    onSuccess: (_data, variables) => {
      invalidateActionDependents(queryClient, variables);
    },
  });
};

export const useResolveBillingReconciliationVarianceActions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resolveBillingReconciliationVarianceActions,
    onSuccess: (_data, variables) => {
      invalidateActionDependents(queryClient, variables);
    },
  });
};

export const useResetBillingReconciliationVarianceActions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resetBillingReconciliationVarianceActions,
    onSuccess: (_data, variables) => {
      invalidateActionDependents(queryClient, variables);
    },
  });
};

export const useUpdateBillingReconciliationLifecycleAlert = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateBillingReconciliationLifecycleAlert,
    onSuccess: (data, variables) => {
      reconcileLifecycleAlertCaches(queryClient, data, variables);
      scheduleLifecycleDependents(queryClient, { ...variables, runId: data?.runId || variables?.runId });
    },
  });
};
const hookSurface = [
  useBillingReconciliationRuns, useBillingReconciliationHistory, useBillingReconciliationHistoryBacLookup,
  useBillingReconciliationVariances, useBillingReconciliationFileHealth, useBillingReconciliationFileHealthSummary,
  useRefreshBillingReconciliationFileHealth, useReviewBillingReconciliationFileHealth, useBulkReviewBillingReconciliationFileHealth,
  useBillingReconciliationLifecycleAlerts, useBillingReconciliationCredits, useBillingReconciliationDpeActions,
  useBillingReconciliationAppSheetAccounts, useBillingReconciliationBacAccounts, useBillingReconciliationGmRows, useCreateBillingReconciliationCredit,
  useBillingReconciliationRowEvidence, useBillingReconciliationFullEvidence, useBillingReconciliationContextWarmStatus,
  useQueueBillingReconciliationContextWarm, useRefreshBillingReconciliationBacContext, useBillingReconciliationCatalog,
  useBillingReconciliationNoteTemplates, useBillingReconciliationVarianceActions, useBillingReconciliationExportPreview,
  useBillingReconciliationExports, useBillingReconciliationSuggestedMatches, useBillingReconciliationRecurringRules,
  useCreateBillingReconciliationRun, usePreviewBillingReconciliationHistoricalBackfill, useUpdateBillingReconciliationHistoryAdjustment,
  useImportBillingReconciliationHistoricalBackfill, useDeleteBillingReconciliationRun, useCreateBillingReconciliationNote,
  useUpdateBillingReconciliationNote, useDeleteBillingReconciliationNote, useCreateBillingReconciliationVarianceAction,
  useCreateBillingReconciliationDpeAction, useUpdateBillingReconciliationDpeAction, useDeleteBillingReconciliationDpeAction,
  useSendBillingReconciliationDpeActions, useUpdateBillingReconciliationVarianceAction, useDeleteBillingReconciliationVarianceAction,
  useSaveBillingReconciliationVarianceActions, useResolveBillingReconciliationVarianceActions, useResetBillingReconciliationVarianceActions,
  useConfirmBillingReconciliationSuggestedMatch, useRejectBillingReconciliationSuggestedMatch, usePromoteBillingReconciliationActionToRecurringRule,
  useUpdateBillingReconciliationRecurringRule, useUpdateBillingReconciliationVarianceReview, useResetBillingReconciliationVarianceReviews,
  useUpdateBillingReconciliationLifecycleAlert,
  useRefreshBillingReconciliationVarianceClassifications,
  useUpdateBillingReconciliationCatalogItem, useMarkBillingReconciliationCatalogItemReviewed, downloadBillingReconciliationExportFile,
  downloadBillingReconciliationActionSummaryCsvFile, downloadBillingReconciliationExportLineageCsvFile,
  downloadBillingReconciliationExportArtifactFile, downloadBillingReconciliationExportBundleFile,
];
export const createBillingReconciliationHooks = () => Object.fromEntries(hookSurface.map((entry) => [entry.name, entry]));
